import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import OptionList from 'jl-design-system/components/option/OptionList';
import Checkbox from 'jl-design-system/components/checkbox/Checkbox';

import { ConnectedWithAnalytics } from '../../with-analytics.hoc';
import styles from './CheckboxesQuestion.scss';

export class CheckboxesQuestion extends PureComponent {
  onChange = (displayName) => {
    const { onChange, value } = this.props;
    const newValue = this.parse(value).filter((val) => val !== '');
    if (this.isOptionChecked(displayName)) {
      newValue.splice(newValue.indexOf(displayName), 1);
    } else {
      newValue.push(displayName);
    }
    onChange(newValue);
  };

  onBlur = () => {
    const { value, onBlur } = this.props;
    onBlur(this.parse(value));
  };

  parse = (value) => {
    try {
      return JSON.parse(value);
    } catch {
      return [];
    }
  };

  isOptionChecked(displayName) {
    const { value } = this.props;
    return this.parse(value).indexOf(displayName) !== -1;
  }

  render() {
    const { id: questionId, options, imageUrl } = this.props;
    return (
      <div className={styles.ListWrapper}>
        <OptionList
          name={questionId}
          isButtonList={false}
          isControlled
          data-testid="CheckboxesQuestionOptionList"
        >
          {options.map((option) => {
            const { displayName, id: optionId } = option;
            const isChecked = this.isOptionChecked(displayName);
            return (
              <Checkbox
                id={`${questionId}_${optionId}`}
                label={displayName}
                value={displayName}
                isControlled
                checked={isChecked}
                onBlur={this.onBlur}
                onChange={() => this.onChange(displayName)}
                key={optionId}
                name={questionId}
                data-testid="CheckboxesQuestionOption"
              />
            );
          })}
        </OptionList>
        {imageUrl ? (
          <div className={styles.questionImgWrapper}>
            <img src={imageUrl} alt="ear-piercing-points" title="Ear Piercing" />
          </div>
        ) : null}
      </div>
    );
  }
}

CheckboxesQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  imageUrl: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export const CheckboxesQuestionWithAnalytics = ConnectedWithAnalytics()(CheckboxesQuestion);
